// preezie ga4 tracking code and searchbox chatbot ai button trigger js

//preezie ai icon trigger
// (function () {

//   function hidePreezieLauncher() {

//     const app = document.querySelector("#preezie-ai-app");

//     if (!app?.shadowRoot) return;


//     const trigger = app.shadowRoot.querySelector(
//       "#prz-trigger-bar-input"
//     );


//     if (trigger) {

//       const wrapper = trigger.closest(".sc-ifyrAs");

//       if (wrapper) {
//         wrapper.style.setProperty(
//           "display",
//           "none",
//           "important"
//         );
//       }

//     }


//     const liveChat = app.shadowRoot.querySelector(
//       ".sc-gjLLEI.fGnhJd"
//     );

//     if (liveChat) {
//       liveChat.style.setProperty(
//         "display",
//         "none",
//         "important"
//       );
//     }

//   }


//   const observer = new MutationObserver(() => {
//     hidePreezieLauncher();
//   });


//   function start() {

//     const app = document.querySelector("#preezie-ai-app");

//     if (!app?.shadowRoot) {
//       requestAnimationFrame(start);
//       return;
//     }


//     hidePreezieLauncher();


//     observer.observe(app.shadowRoot, {
//       childList:true,
//       subtree:true
//     });

//   }


//   start();

// })();

// document.addEventListener("click", function(e) {
//   const btn = e.target.closest(".search__ai");

//   if (!btn) return;

//   e.preventDefault();

//   if (typeof openPrzChatModal === "function") {
//     openPrzChatModal();
//   }
// });

//preezie tracking script for GA4
(function() {
  window.dataLayer = window.dataLayer || [];

  var pendingEvents = [];
  var gtagReadyChecked = false;

  function flushPending() {
    if (typeof window.gtag !== 'function') return;
    while (pendingEvents.length) {
      var item = pendingEvents.shift();
      window.gtag('event', item.name, item.payload);
    }
  }

  function forward(entry) {
    if (!entry || typeof entry.event !== 'string') return;
    if (entry.event.indexOf('aishoppingassistant') !== 0) return;

    var eventName = entry.event.replace(/\./g, '_'); // aishoppingassistant.pdp.view -> aishoppingassistant_pdp_view
    var payload = entry.aishoppingassistant || {};

    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    } else {
      pendingEvents.push({ name: eventName, payload: payload });
      waitForGtag();
    }
  }

  function waitForGtag() {
    if (gtagReadyChecked) return;
    gtagReadyChecked = true;

    var attempts = 0;
    var maxAttempts = 50; // ~10 seconds at 200ms
    var interval = setInterval(function() {
      attempts++;
      if (typeof window.gtag === 'function') {
        clearInterval(interval);
        flushPending();
        gtagReadyChecked = false; // allow future re-checks if needed
      } else if (attempts >= maxAttempts) {
        clearInterval(interval);
        gtagReadyChecked = false;
      }
    }, 200);
  }

  // catch anything already pushed before this script ran
  window.dataLayer.forEach(forward);

  var originalPush = window.dataLayer.push;
  window.dataLayer.push = function() {
    for (var i = 0; i < arguments.length; i++) forward(arguments[i]);
    return originalPush.apply(window.dataLayer, arguments);
  };
})();